// ════════════════════════════════════════════════════════════════════════
//  CONFIRMAR CORREO NUEVO — aquí llega el enlace de Mi perfil → Correo
//
//  El token de la dirección basta: no hace falta tener la sesión abierta (el
//  enlace se suele abrir desde el móvil). Si la sesión de ESTA cuenta sí está
//  abierta en este navegador, se actualiza el correo guardado para que el menú
//  del nombre no enseñe el viejo.
// ════════════════════════════════════════════════════════════════════════
import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getStoredUser, getToken, mensajeDeError, updateStoredUser } from '../api';
import { confirmEmailChange } from '../accountApi';
import './Login.css';
import { useT } from '../i18n';
import LangToggle from '../components/LangToggle';
import { IS_PHONE } from '../device';
import { useLogo } from '../theme';

export default function ConfirmEmail() {
  const logoSrc = useLogo();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  // 'confirmando' | 'ok' | 'error'
  const [estado, setEstado] = useState(token ? 'confirmando' : 'error');
  const t = useT();
  // Sin token el aviso se traduce al pintar (ver `texto` abajo) para que siga al
  // interruptor de idioma.
  const [mensaje, setMensaje] = useState('');
  // El enlace es de un solo uso: StrictMode ejecuta el efecto dos veces en
  // desarrollo, y el segundo intento contestaría "ya se usó" encima del éxito.
  const enviado = useRef(false);

  useEffect(() => {
    if (!token || enviado.current) return;
    enviado.current = true;
    confirmEmailChange(token)
      .then((res) => {
        if (getStoredUser().id === res.user_id) updateStoredUser({ email: res.email });
        setMensaje(res.mensaje);
        setEstado('ok');
      })
      .catch((err) => {
        setMensaje(mensajeDeError(err, t('auth.confirm.errorFallback')));
        setEstado('error');
      });
  }, [token, t]);

  const conSesion = Boolean(getToken());
  const texto = token ? mensaje : t('auth.confirm.missingToken');

  return (
    <div className="login-page">
      <LangToggle style={{ position: 'fixed', top: 12, right: 16, zIndex: 10 }} />
      {/* Teléfono: sin vídeo de fondo (pesa y gasta batería); queda el degradado. */}
      {!IS_PHONE && (
        <video className="login-video-bg" autoPlay muted playsInline loop>
          <source src="/videos/background.mp4" type="video/mp4" />
        </video>
      )}
      <div className="login-overlay" />
      <div className="login-container">
        <div className="login-card-glow">
          <div className="login-card">
            <div className="login-logo">
              <img src={logoSrc} alt="DragonAudio" className="logo-img" />
              <h1 className="login-title">DragonAudio</h1>
            </div>

            {estado === 'confirmando' && (
              <p className="login-pista login-pista--centrada">{t('auth.confirm.confirming')}</p>
            )}
            {estado === 'ok' && <p className="login-aviso">{texto}</p>}
            {estado === 'error' && <p className="login-error">{texto}</p>}

            {estado !== 'confirmando' && (
              <p className="login-register">
                <Link to={conSesion ? '/music' : '/'}>{conSesion ? t('auth.confirm.backToApp') : t('auth.confirm.goLogin')}</Link>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
